import React from "react"

const BenefitsSection = ({ benefits, page, itemClassName, benefitImgs }) => {
  return (
    <section className="py-7 text-center border-bottom">
      <div className="container">
        <h2 className="section-title text-center">{benefits.title}</h2>
        <div className="lead mb-5" />
        <div className="row">
          {benefits.items.map((item, i) => (
            <div key={i} className={itemClassName}>
              <div className="my-3">
                <img
                  data-sal="fade"
                  data-sal-easing="ease-in-out"
                  data-sal-duration="1500"
                  className="mb-0"
                  alt="MoBerries Benefit"
                  height="160"
                  src={benefitImgs[i]}
                />
              </div>
              <h4>{item.title}</h4>
              <p className="mb-4">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default BenefitsSection
